<template>
  <div class="mt-2 p-4">
    <CModal
        class="modals"
        size="lg"
        :centered="true"
        color="info"
        :show.sync="infoModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
          <div class="headers-modal">
              <CRow>
                  <CCol sm="10">
                      <div>Daftar Pegawai {{headerModal}}</div>
                  </CCol>
                  <CCol sm="2" class="text-right">
                      <img :src="closeIcon" @click="infoModal = false" style="cursor:pointer" width="20px" height="20px"/>
                  </CCol>
              </CRow>
          </div>
        </template>
        <template #body-wrapper>
          <div class="bodys-modal" style="padding-right:20px;padding-top:5px;padding-left:20px">
            <CRow>
                <CCol sm="6">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:left"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:left" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:left" v-model="page" class="text-center rounded p-1" type="text">
                    <span style="float:left">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                </CCol>
                <CCol sm="6"></CCol>
            </CRow>
            <table class="w-100">
              <thead>
                <tr>
                  <th style="width:25%;max-width:25%">Nama</th>
                  <th style="width:25%;max-width:25%">NIP</th>
                  <th style="width:25%;max-width:25%">Bidang</th>
                  <th style="width:25%;max-width:25%">Jabatan</th>
                </tr>
              </thead>
              <tbody v-if="datas.length != 0">
                <tr v-for="(item, id) in datas" :key="id">
                  <td style="width:25%;max-width:25%">{{item.nama}}</td>
                  <td style="width:25%;max-width:25%">{{item.nik}}</td>
                  <td style="width:25%;max-width:25%">{{item.bidang}}</td>
                  <td style="width:25%;max-width:25%">{{item.jabatan}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="4">
                    Data Tidak Ditemukan
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </template>
      <template #footer-wrapper>
          <CRow style="padding-top:20px;padding-bottom:20px;padding-left:20px;padding-right:20px">
            <CCol sm="10">
            </CCol>
            <CCol class="text-right" sm="2">
                <CButton @click="infoModal = false" class="modal-buttons modal-button-cancel mr-1">Tutup</CButton>
            </CCol>
          </CRow>
      </template>
    </CModal>
    <CRow>
      <CCol sm="12">
        <h5 style="color:black">Dashboard</h5>
        <hr class="mt-1 mb-4"/>
      </CCol>
    </CRow>
    <CRow class="mb-4">
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">WFH</div>
                    <div class="card-subtitle">Data pegawai hari ini bekerja di rumah</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <span @click="showDetail('WFH')" style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;cursor:pointer" class="text-left">{{wfh}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{wfh}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                    </div>
                    <div class="col-md-6 pt-1">
                        <div class="card-emblem">
                            <img :src="iconWfh" width="20px" height="20px" />
                        </div>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">WFO</div>
                    <div class="card-subtitle">Data pegawai hari ini bekerja di kantor</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <span @click="showDetail('WFO')" style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;cursor:pointer" class="text-left">{{wfo}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{wfo}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                    </div>
                    <div class="col-md-6 pt-1">
                        <div class="card-emblem">
                            <img :src="iconWfo" width="20px" height="20px" />
                        </div>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Cuti</div>
                    <div class="card-subtitle">Data pegawai hari ini cuti</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <span @click="showDetail('Cuti')" style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;cursor:pointer" class="text-left">{{cuti}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{cuti}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                    </div>
                    <div class="col-md-6 pt-1">
                        <div class="card-emblem">
                            <img :src="iconCuti" width="20px" height="20px" />
                        </div>
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="3 d-flex">
            <div style="border-radius:8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
                <div class="mb-3">
                    <div class="card-title mb-1">Terlambat</div>
                    <div class="card-subtitle">Data pegawai terlambat kerja</div>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-6">
                        <span @click="showDetail('Terlambat')" style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600;cursor:pointer" class="text-left">{{telat}}</span>
                        <!-- <span style="font-size: 28px;color: rgba(16, 16, 16, 1);font-weight:600" class="text-left">{{telat}}</span> -->
                        <span style="font-size: 12px;color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
                    </div>
                    <div class="col-md-6 pt-1">
                        <div class="card-emblem">
                            <img :src="iconTelat" width="20px" height="20px" />
                        </div>
                    </div>
                </div>
            </div>
        </CCol>
    </CRow>
    <CRow>
      <CCol sm="5">
        <PegawaiChart :tipe="tipe" :jumlah="jumlah" />
      </CCol>
      <CCol sm="7">
        <KehadiranChart :snt="snt" :snnt="snnt" :slt="slt" :slnt="slnt" :rbt="rbt" :rbnt="rbnt" :kmt="kmt" :kmnt="kmnt" :jmt="jmt" :jmnt="jmnt" :sbt="sbt" :sbnt="sbnt" :mgt="mgt" :mgnt="mgnt"/>
      </CCol>
      <CCol sm="6">
        <PjtkChart v-if="flagPjtk == 'Y'" :tipe2="tipe2" :jumlah2="jumlah2" />
      </CCol>
      <CCol sm="12">
        <AbsensiKehadiran @flag="dataDua"/>
      </CCol>
      <CCol sm="12">
        <WFOWFHChart @flags="dataTiga"/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import KehadiranChart from './widgets/KehadiranChart';
import PegawaiChart from './widgets/PegawaiChart';
import WFOWFHChart from './widgets/WFOWFHChart';
import PjtkChart from './widgets/PjtkChart';
import AbsensiKehadiran from './widgets/AbsensiKehadiran';
import {DataApi} from "../service/DataApi";

export default {
  name: 'Dashboard',
  components: {
    PegawaiChart,
    PjtkChart,
    KehadiranChart,
    AbsensiKehadiran,
    WFOWFHChart
  },
  data () {
    return {
      infoModal: false,
      headerModal: '',
      type: '',
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      iconWfh: require('../assets/menu/icon_home.svg'),
      closeIcon: require('../assets/menu/icon_close.svg'),
      iconWfo: require('../assets/menu/icon_office.svg'),
      iconCuti: require('../assets/menu/icon_leave_blue.svg'),
      iconTelat: require('../assets/menu/icon_late.svg'),

      wfo: 0,
      wfh: 0,
      cuti: 0,
      telat: 0,
      tipe: [],
      jumlah: [],
      snt: 0,
      snnt: 0,
      slt: 0,
      slnt: 0,
      rbt: 0,
      rbnt: 0,
      kmt: 0,
      kmnt: 0,
      jmt: 0,
      jmnt: 0,
      sbt: 0,
      sbnt: 0,
      mgt: 0,
      mgnt: 0,

      flagPjtk: 'Y',
      tipe2: [],
      jumlah2: [],

      flagKehadiran: false,
      flagWFOWFH: false,
      flagPegawai: false
    }
  },
  watch: {
    page() {
      this.showDetail(this.type)
    },
    headerModal() {
      this.page = 1
    },
    flagKehadiran() {
      this.offLoading()
    },
    flagWFOWFH() {
      this.offLoading()
    },
    flagPegawai() {
      this.offLoading()
    },
  },
  methods: {
    showDetail(val) {
      let type = ''
      if(val == 'WFH') {
        type = 'H'
      } else if(val == 'WFO') {
        type = 'O'
      } else if(val == 'Cuti') {
        type = 'C'
      } else if(val == 'Terlambat') {
        type = 'T'
      }
      this.type = val
      let payload = {
        bidang: '',
        idPegawai: '',
        jabatan: '',
        limit: 20,
        nama: '',
        pageIn: this.page,
        type: type
      }
      DataApi.post("dashboard/detail", payload)
      .then(response => {
        let res = response.data
        if(res.success == true) {
          this.datas = res.data.data
          this.totalRow = res.data.totalRow
          this.firstPage = (((this.page - 1) * this.size) + 1 )
          this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
          this.totalPage = Math.floor(this.totalRow/this.size)
          let modAr = this.totalRow%this.size
          if(modAr != 0) {
              this.totalPage = this.totalPage + 1
          } else {
              //
          }
          this.infoModal = true
          this.headerModal = val
        } else {
          this.totalRow = 0
          this.firstPage = 0
          this.lastPage = 0
          this.totalPage = 1
          this.datas = []
          this.infoModal = true
          this.headerModal = val
        }
        
      })
    },
    movePage(direction) {
        if(direction == 'prev') {
            this.page = this.page -  1
        } else {
            this.page = this.page +  1
        }
    },
    validatePage(page) {
        if(page > this.totalPage) {
            this.page = this.totalPage
        }
    },
    getDataDashboard() {
      let payload = {}
      DataApi.post("dashboard/satu", payload)
      .then(res => {
          let response = res.data
          if(response.success == true) {
            let temp = response.data[0]
            this.flagPjtk = temp.pjtk
            if(temp.wfo != 'null') {
              this.wfo = temp.wfo
            } else {
              this.wfo = 0
            }
            if(temp.wfh != 'null') {
              this.wfh = temp.wfh
            } else {
              this.wfh = 0
            }
            if(temp.cuti != 'null') {
              this.cuti = temp.cuti
            } else {
              this.cuti = 0
            }
            if(temp.telat != 'null') {
              this.telat = temp.telat
            } else {
              this.telat = 0
            }
            
            this.tipe = temp.daftarTipe
            this.jumlah = temp.daftarJumlah

            this.tipe2 = temp.daftarPjtk
            this.jumlah2 = temp.daftarJumlahPjtk
            

            this.snt = temp.snt
            this.snnt = temp.snnt
            this.slt = temp.slt
            this.slnt = temp.slnt
            this.rbt = temp.rbt
            this.rbnt = temp.rbnt
            this.kmt = temp.kmt
            this.kmnt = temp.kmnt
            this.jmt = temp.jmt
            this.jmnt = temp.jmnt
            this.sbt = temp.sbt
            this.sbnt = temp.sbnt
            this.mgt = temp.mgt
            this.mgnt = temp.mgnt
          } else {
              this.errorMessage = response.message
          }
          this.flagPegawai = true
      })
    },

    dataDua(value) {
      if(value == 1) {
        this.flagKehadiran = true
      }
    },
    dataTiga(value) {
      if(value == 1) {
        this.flagWFOWFH = true
      }
    },
    offLoading() {
      if(this.flagKehadiran == true && this.flagWFOWFH == true && this.flagPegawai == true) {
        this.$store.state.loadingScreen = false
      }
    }
  },
  mounted() {
    this.getDataDashboard()
    this.$store.state.loadingScreen = true
  }
}
</script>

<style scoped>
.flexible {
  flex-grow: 1;
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modals {
  overflow-y: initial !important;
}
.bodys-modal {
  overflow-y: auto;
  height: 65vh;
}
.modal-buttons {
    width:100%;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>